export class Forms{
    init(){
        $('#competitionForm').on('submit', function(e) {
            var form = e.target;
            e.preventDefault();
            var formData = new FormData($(form)[0]);
            formData.append('image', $('input[type=file]')[0].files[0]);
            $.ajax({
                url: $(form).attr("action"),
                method: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                beforeSend: function() {
                    $(form).find('button').prop('disabled', 'disabled');
                    $(form).find('.form__message').remove();
                },
                success: function() {
                    $(form).find('input, textarea').val('');
                    $(form).fadeOut(500, function() {
                        $(form).replaceWith('<div class="form__message form__message--success h4 ff-secondary text-shadow-short text-center">Dziękujemy za zgłoszenie.</div>').fadeIn(500);
                    });
                },
                error: function(e,errorMessage) {
                    $(form).fadeOut(500, function() {
                        let msg = '';
                        for (let field in e.responseJSON) {
                            for (let i in e.responseJSON[field]) {
                                msg = '<p>' + e.responseJSON[field][i] + '</p>'
                            }
                            $(form).find('[name=' + field + ']').addClass('is-invalid');
                        }
                        $(form).append('<div class="col-12 form__message form__message--error h4 ff-secondary text-shadow-short text-center">Zgłoszenie <u>nie</u> zostało wysłane. Wypenij poprawnie formularz.' + msg + '</div>').fadeIn(500);
                    });
                    $(form).find('button').removeAttr('disabled');
                }
            });
        });

        $('#competition-voting-form').on('submit', function(e) {
            var form = e.target;
            e.preventDefault();
            var formData = new FormData($(form)[0]);
            
            $.ajax({
                url: $(form).attr("action"),
                method: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                beforeSend: function() {
                    $(form).find('button').prop('disabled', 'disabled');
                    $(form).find('.form__message').remove();
                },
                success: function() {
                    $(form).find('input, textarea').val('');
                    $(form).fadeOut(500, function() {
                        $(form).replaceWith('<div class="form__message form__message--success h4 ff-secondary text-shadow-short text-center">Na podany adres email został wysłany link do potwierdzenia głosu. <br/>Twój głos będzie się liczył dopiero po jego potwierdzeniu.</div>').fadeIn(500);
                    });
                },
                error: function(e,errorMessage) {
                    $(form).fadeOut(500, function() {
                        let msg = '';
                        for (let field in e.responseJSON) {
                            for (let i in e.responseJSON[field]) {
                                msg = '<p>' + e.responseJSON[field][i] + '</p>'
                            }
                            $(form).find('[name=' + field + ']').addClass('is-invalid');
                        }
                        $(form).append('<div class="col-12 form__message form__message--error h4 ff-secondary text-shadow-short text-center">Zgłoszenie <u>nie</u> zostało wysłane. Wypenij poprawnie formularz.' + msg + '</div>').fadeIn(500);
                    });
                    $(form).find('button').removeAttr('disabled');
                }
            });
        });

        $(document).ready(function() {
            if($('.select2me').length){
                $('.select2me').select2();
            }
        });
    }
}